import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class RadniNaloziDokumentiService {
  constructor(private _http: HttpClient) {}

  dohvatiIzvjestaje(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dokumentiPopis_poNalogu', a)
      .pipe(map((res: any) => res));
  }



}